// extracted by mini-css-extract-plugin
module.exports = {"image":"Image-module--image--aDaXM","resized":"Image-module--resized--ZbcUK","centered":"Image-module--centered--2Dyhx","figure":"Image-module--figure--2WJLx"};